// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__VN18T","consentsList":"PatientConsents_consentsList__2bVd0","consentsListEmpty":"PatientConsents_consentsListEmpty__p2ZHC"};